var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcBulkUpdate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.32 6.17578H5C3.895 6.17578 3 7.12478 3 8.29378V18.8818C3 20.0518 3.895 20.9998 5 20.9998H16C17.105 20.9998 18 20.0518 18 18.8818V11.1318L14.086 15.2758C13.7442 15.6413 13.2991 15.8938 12.81 15.9998L10.129 16.5678C8.379 16.9378 6.837 15.3048 7.187 13.4528L7.723 10.6138C7.82 10.1018 8.058 9.63078 8.407 9.26178L11.32 6.17578Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8462 4.31704C19.7451 4.06107 19.5969 3.82634 19.4092 3.62504C19.2247 3.42817 19.0022 3.27068 18.7552 3.16204C18.5118 3.05518 18.249 3 17.9832 3C17.7174 3 17.4545 3.05518 17.2112 3.16204C16.9642 3.27068 16.7417 3.42817 16.5572 3.62504L16.0112 4.20304L18.8632 7.22304L19.4092 6.64404C19.5988 6.44427 19.7473 6.20914 19.8462 5.95204C20.0522 5.42651 20.0522 4.84257 19.8462 4.31704ZM17.4502 8.72004L14.5972 5.69904L9.82019 10.759C9.74971 10.8341 9.70217 10.9278 9.68319 11.029L9.14719 13.869C9.07719 14.239 9.38619 14.565 9.73519 14.491L12.4172 13.924C12.5148 13.9023 12.6036 13.8518 12.6722 13.779L17.4502 8.72004Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBulkUpdate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-bulk-update.587295db.svg";
export { ForwardRef as ReactComponent };